module.exports = __webpack_public_path__ + "static/media/icon_r.b668d2e9.svg";